window.maxCharms = 25;
window.maxCharmsBFCM = 10;
window.progressSteps = [
    { 
      threshold: 5, 
      discount: '10%',
      discountPercentage: 10,
      charmCount: 5,
      inProgressText: 'Add {count} more Charms and get',
      completedText: '🎉 Congrats! You have unlocked',
      discountText: `10% OFF + FREE Travel Kit (${Shopify.formatMoney(window.priceConfig.travel_kit)} Value)`,
      discountTextWithHolder: '10% OFF and a Travel Kit'
    },
    { 
      threshold: 10, 
      discount: '20%', 
      discountPercentage: 20,
      charmCount: 10,
      inProgressText: 'Add {count} more Charms and get',
      completedText: '🎉 Congrats! You have unlocked',
      discountText: `20% OFF + FREE Charm Holder (${Shopify.formatMoney(window.priceConfig.charm_holder)} Value)`
    },
    { 
      threshold: 15, 
      discount: '30%', 
      discountPercentage: 30,
      charmCount: 15,
      inProgressText: 'Add {count} more Charms and get',
      completedText: '🎉 Congrats! You have unlocked',
      discountText: '30% OFF'
    },
    { 
      threshold: 20, 
      discount: '40%', 
      discountPercentage: 40,
      charmCount: 20,
      inProgressText: 'Add {count} more Charms and get',
      completedText: '🎉 Congrats! You have unlocked',
      discountText: '40% OFF'
    },
    { 
      threshold: 25, 
      discount: '50%', 
      discountPercentage: 50,
      charmCount: 25,
      inProgressText: 'Add {count} more Charms and get',
      completedText: '🎉 Congrats! You have unlocked',
      discountText: '50% OFF'
    }
]


window.progressStepsBFCM = [
  { 
    threshold: 5,
    discount: 'FREE',
    discountPercentage: 0,
    charmCount: 5,
    inProgressText: 'Add {count} more Charms and get',
    completedText: '🎉 Congrats! You have unlocked',
    discountText: `FREE Travel Kit (${Shopify.formatMoney(window.priceConfig.travel_kit)} Value)`,
    discountTextWithHolder: 'a Travel Kit (${Shopify.formatMoney(window.priceConfig.travel_kit)} Value)'
  },
  { 
    threshold: 10, 
    discount: 'FREE',
    discountPercentage: 0,
    charmCount: 10,
    inProgressText: 'Add {count} more Charms and get',
    completedText: '🎉 Congrats! You have unlocked',
    discountText: `FREE Charm Holder (${Shopify.formatMoney(window.priceConfig.charm_holder)} Value)`
  }
]

// URL of resource for cached results (so we don't have to load it every time via liquid)
const charmsFlagsCachedURL = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/cached-countries.json" + "?v=" + new Date().getTime();
const charmsMapsCachedURL = "https://cdn.shopify.com/s/files/1/0259/0451/3109/files/cached-country-maps.json" + "?v=" + new Date().getTime();
// const personalizationPrice = ""

// Check if an item is a charm
function isCharmItem(item) {
  return item.properties && item.properties.__type === 'charm_set';
}

// Check if an item is a charm holder
function isCharmHolder(item) {
  return item.properties && item.properties.__type === 'charm_holder';
}

// Check if an item is a free gift holder
// Check both __freegift property and discount (holder already free from discount code/automatic discount)
function isFreeHolder(item) {
  // Check property __freegift
  if (item.properties && (item.properties.__freegift === 'true' || item.properties.__freegift === true)) {
    return true;
  }
  // Check discount - if there's a discount "Free Charm Holder" or total_discount > 0, then holder is already free
  if (item.discounts && item.discounts.length > 0) {
    const hasFreeHolderDiscount = item.discounts.some(discount => 
      discount.title && discount.title.toLowerCase().includes('free') && 
      discount.title.toLowerCase().includes('holder')
    );
    if (hasFreeHolderDiscount) return true;
  }
  // Check total_discount > 0 and final_price = 0 (holder is already free)
  if (item.total_discount > 0 && item.final_price === 0) {
    return true;
  }
  return false;
}

// Helper function to calculate isFreeHolderUnlocked based on charm count and cart data
function calculateIsFreeHolderUnlocked(charmCount, cart) {
  if (!cart || !cart.items) {
    // If no cart, just check if charmCount >= 10
    return charmCount >= 10;
  }
  
  let holderCount = 0;
  let freeHolderCount = 0;
  
  // Count holders in the cart
  cart.items.forEach(item => {
    // Check if the item is a holder
    if (isCharmHolder(item)) {
      holderCount += item.quantity;
      // Count free holders
      if (isFreeHolder(item)) {
        freeHolderCount += item.quantity;
      }
    }
  });
  
  // Logic: 
  // 1. 10 charm sets trở lên → 1 holder free (chỉ 1 lần, không phải mỗi 10 charms)
  // 2. Buy 1 holder → get 1 holder free (logic "buy 1 get 1")
  let shouldBeFree = false;
  
  // Check condition: >= 10 charm sets then first holder is free (only once)
  if (charmCount >= 10) {
    // Calculate number of holders already free from discount
    const freeHoldersFromDiscount = freeHolderCount;
    
    // Calculate number of holders that are NOT free (holders đã mua)
    const paidHolders = holderCount - freeHoldersFromDiscount;
    
    // Logic:
    // - 1 holder free from "10 charms → 1 holder free" (chỉ 1 lần)
    // - Còn lại: paidHolders - 1 (vì 1 holder đã free từ charms)
    // - Logic "buy 1 get 1": mỗi cặp (1 mua + 1 free) = 1 holder free
    // - Số holders free từ "buy 1 get 1" = Math.floor((paidHolders - 1) / 2)
    // - Tổng holders free = 1 (từ charms) + Math.floor((paidHolders - 1) / 2) (từ "buy 1 get 1")
    const remainingPaidHolders = Math.max(0, paidHolders - 1); // Trừ 1 holder đã free từ charms
    const freeHoldersFromBuy1Get1 = Math.floor(remainingPaidHolders / 2); // Mỗi cặp = 1 free
    const totalFreeHolders = 1 + freeHoldersFromBuy1Get1;
    
    // Calculate current free holders
    const currentFreeHolders = freeHoldersFromDiscount;
    
    // If current free holders < total free holders needed, then next holder should be free
    // But only when total holders < total free holders needed (to be able to add new holder)
    if (holderCount === 0) {
      // No holders yet, first holder should be free (from "10 charms → 1 holder free")
      shouldBeFree = true;
    } else if (currentFreeHolders < totalFreeHolders) {
      // We need more free holders
      // Check if we can add more holders (total holders should be less than total free holders needed)
      // Actually, we should allow adding holders until we reach totalFreeHolders
      // But we need to check: if holderCount < totalFreeHolders, we can still add free holders
      if (holderCount < totalFreeHolders) {
        shouldBeFree = true;
      }
    }
  }
  
  return shouldBeFree;
}

function updateCartCharmCountFromCartData(cart) {
  if (!cart || !cart.items) {
    window.isFreeHolderUnlocked = false;
    return 0;
  }
  
  let charmCount = 0;
  
  // Count charms in the cart
  cart.items.forEach(item => {
    // Check if the item is a charm
    if (isCharmItem(item)) {
      charmCount += item.quantity;
    }
  });
  
  // Calculate and set isFreeHolderUnlocked based on cart data
  window.isFreeHolderUnlocked = calculateIsFreeHolderUnlocked(charmCount, cart);
  
  return charmCount;
}

window.discountSettings = {
  progressSteps,
  updateCartCharmCountFromCartData,
  calculateIsFreeHolderUnlocked, // Export helper function
  charmsFlagsCachedURL, 
  charmsMapsCachedURL,
  // personalizationPrice
}
